<template>
	<glass-card class="privacy-policy-container">
		<div class="container py-5">
			<h1>Privacy Policy</h1>
			<p>Last updated: 3/12/2025</p>

			<h2>Introduction</h2>
			<p>
				Welcome to the Grub Vision Privacy Policy. Your privacy is important to
				us.
			</p>
			<p>
				Grub Vision ("we", "our", or "us") is committed to protecting your
				personal information and your right to privacy. If you have any
				questions or concerns about this privacy policy, or our practices with
				regards to your personal information, please contact us at
				sdeutsch@digitalfuturelabs.com.
			</p>

			<h2>Information We Collect</h2>
			<p>
				When you use our application, we may collect the following information:
			</p>
			<ul>
				<li>
					Personal Information:
					<ul>
						<li>Contact Information: Your name, email address</li>
						<li>Account Information: Your password</li>
						<li>
							Location Information: Information about your location obtained
							from GPS, which you have consented to share with us
						</li>
						<li>
							Media Information: Images captured from your device's camera,
							which you have granted permission for us to access
						</li>
						<li>
							Health Information: Your weight, blood sugar levels, allergies,
							and other health-related data that you have provided to us
						</li>
					</ul>
				</li>
				<li>
					Usage Data: Information on how you use the app and its services.
				</li>
				<li>
					Device Data: Information about your device, like your IP address and
					browser type.
				</li>
			</ul>

			<h2>How We Use Your Information</h2>
			<p>We use the information we collect in various ways, including to:</p>
			<ul>
				<li>
					Provide, operate, and maintain our app, including using location data
					to find restaurant locations by querying our custom database and
					third-party APIs, detecting when you're at a restaurant, using camera
					data to identify foods, and using food/health information for
					AI-driven features
				</li>
				<li>Improve, personalize, and expand our app</li>
				<li>Understand and analyze how you use our app</li>
				<li>Develop new products, services, features, and functionality</li>
				<li>
					Communicate with you, either directly or through one of our partners
				</li>
			</ul>

			<h2>Sharing Your Information</h2>
			<p>
				We do not share or sell your personal information to third parties.
				However, we may share your information in the following situations:
			</p>
			<ul>
				<li>
					With service providers: We may share your information with service
					providers who perform services for us and require access to such
					information to do that work. Specifically:
					<ul>
						<li>
							Location data is shared with third-party APIs to find restaurant
							locations.
						</li>
						<li>
							Camera images are shared with third-party image recognition
							services to identify foods.
						</li>
						<li>
							Session snippets are shared with Sentry for error reporting.
						</li>
						<li>
							Food/Health information is shared with third-party AI services for
							analysis.
						</li>
					</ul>
				</li>
				<li>
					For legal reasons: We may share information when legally required to
					do so, to comply with applicable law or respond to valid legal
					processes, such as a search warrant or a court order.
				</li>
			</ul>

			<h2>Use of Third-Party Services</h2>
			<p>
				We engage certain trusted third parties to perform functions and provide
				services to our app, such as:
			</p>
			<ul>
				<li>
					Third-party APIs for GPS tracking and restaurant location services
				</li>
				<li>Image recognition services for food identification</li>
				<li>Sentry for error reporting</li>
				<li>AI services for food/health information analysis</li>
			</ul>
			<p>
				We share your personal information with these third parties, but only to
				the extent necessary to perform these services.
			</p>

			<h2>Data Analysis</h2>
			<p>
				We use third-party services to analyze the images you capture with the
				camera to identify foods. Based on this identification, we may provide
				nutritional estimates using our own data or third-party sources. These
				estimates are provided for informational purposes only and may not
				reflect the actual nutritional content of the food items.
			</p>

			<h2>Your Privacy Rights</h2>
			<p>
				You have the right to request access, correction, or deletion of your
				personal data. You also have the right to object to the processing of
				your personal data, and in some jurisdictions, you have the right to
				data portability.
			</p>

			<h2>Cookies Policy</h2>
			<p>
				We use cookies and similar tracking technologies to track activity on
				our app and store certain information. Tracking technologies used are
				beacons, tags, and scripts to collect and track information and to
				improve and analyze our service.
			</p>

			<h2>Security</h2>
			<p>
				We take the security of your personal information seriously and use
				appropriate technical and organizational measures to protect it against
				unauthorized or unlawful access, loss, destruction, or damage.
			</p>

			<h2>Children's Privacy</h2>
			<p>
				Our application does not address anyone under the age of 13. We do not
				knowingly collect personally identifiable information from children
				under 13.
			</p>

			<h2>Changes to This Privacy Policy</h2>
			<p>
				We may update our Privacy Policy from time to time. We will notify you
				of any changes by posting the new Privacy Policy on this page.
			</p>

			<h2>Contact Us</h2>
			<p>
				If you have any questions about this Privacy Policy, you can contact us
				at sdeutsch@digitalfuturelabs.com.
			</p>
		</div>
	</glass-card>
</template>

<script setup>
	import GlassCard from "@/components/GlassCard.vue"
</script>

<style lang="less" scoped>
	.privacy-policy-container {
		h1,
		h2 {
			color: #ff6400 !important;
		}

		p,
		li {
			color: #ff6400;
		}
		ul {
			list-style-type: none;
			padding-left: 0;
		}
		li {
			padding-left: 1em;
			text-indent: -1em;
		}
	}
</style>
